export const USER_PROFILE_INFO_ADDRESS_FIELD_NAME = 'address'

export const USER_PROFILE_INFO_ADDRESS_2_FIELD_NAME = 'address_2'

export const USER_PROFILE_INFO_BANK_NAME_FIELD_NAME = 'bank_name'

export const USER_PROFILE_INFO_BIC_FIELD_NAME = 'bic'

export const USER_PROFILE_INFO_CITY_FIELD_NAME = 'city'

export const USER_PROFILE_INFO_COUNTRY_FIELD_NAME = 'country'

export const USER_PROFILE_INFO_DEPOSIT_FIELD_NAME = 'deposit'

export const USER_PROFILE_INFO_DEPOSIT_TYPE_FIELD_NAME = 'deposit_type'

export const USER_PROFILE_INFO_EMAIL_FIELD_NAME = 'email'

export const USER_PROFILE_INFO_FIRST_NAME_FIELD_NAME = 'first_name'

export const USER_PROFILE_INFO_FULL_NAME_FIELD_NAME = 'full_name'

export const USER_PROFILE_INFO_FUNDINGS_FIELD_NAME = 'fundings'

export const USER_PROFILE_INFO_GDPR_INFO_FIELD_NAME = 'gdpr_info'

export const USER_PROFILE_INFO_GUARANTEED_VALUE_FIELD_NAME = 'guaranteed_value'

export const USER_PROFILE_INFO_IBAN_FIELD_NAME = 'iban'

export const USER_PROFILE_INFO_LAST_NAME_FIELD_NAME = 'last_name'

export const USER_PROFILE_INFO_MIDDLE_NAME_FIELD_NAME = 'middle_name'

export const USER_PROFILE_INFO_NAME_INFO_FIELD_NAME = 'name_info'

export const USER_PROFILE_INFO_OPEN_AMOUNT_FIELD_NAME = 'open_amount'

export const USER_PROFILE_INFO_PAYMENT_TYPE_FIELD_NAME = 'payment_type'

export const USER_PROFILE_INFO_PHONE_FIELD_NAME = 'phone'

export const USER_PROFILE_INFO_POSTCODE_FIELD_NAME = 'postcode'

export const USER_PROFILE_INFO_PREFERRED_COMMUNICATION_FIELD_NAME =
  'preferred_communication'

export const USER_PROFILE_INFO_REMEDY_FIELD_NAME = 'remedy'

export const USER_PROFILE_INFO_SALUTATION_FIELD_NAME = 'salutation'

export const USER_PROFILE_INFO_STATUS_FIELD_NAME = 'status'

export const USER_PROFILE_INFO_STOP_OVERDUE_NOTICE_FIELD_NAME =
  'stop_overdue_notice'

export const USER_PROFILE_INFO_STREET_FIELD_NAME = 'street'

export const USER_PROFILE_INFO_TERMINATION_DENIED_FIELD_NAME =
  'termination_denied'

export const USER_PROFILE_INFO_TERMINATION_TIME_FIELD_NAME = 'termination_time'

export const USER_PROFILE_INFO_TERMINATION_TIMEFRAME_FIELD_NAME =
  'termination_timeframe'

export const USER_PROFILE_INFO_TITLE_FIELD_NAME = 'title'

export const USER_PROFILE_SALUTATION_OPTIONS_API_PARAMS = {
  object_type: 'user',
}
